"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var SignUpForm_1 = __importDefault(require("./SignUpForm"));
var UserBackNotification_1 = __importDefault(require("./UserBackNotification"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SwitchAuthType_1 = __importDefault(require("../SwitchAuthType"));
var navigation_1 = require("next/navigation");
var react_2 = require("react");
var Lockr = __importStar(require("lockr"));
var FinalStepForm_1 = __importDefault(require("./FinalStepForm"));
// import { useSignUpBonus } from './useSignUpBonus'
var lockrWrapper = function (fn) {
    if (typeof window !== 'undefined')
        return fn();
};
var AUTH_TYPE = 'authType';
var SignUpNew = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var _q = _a.withLabels, withLabels = _q === void 0 ? true : _q, _r = _a.welcomeFields, welcomeFields = _r === void 0 ? ['email', 'password', 'country', 'currency'] : _r, _s = _a.authInputMode, authInputMode = _s === void 0 ? 'light' : _s, isUserWasAuth = _a.isUserWasAuth;
    var _t = (0, react_1.useState)('signup'), step = _t[0], setStep = _t[1];
    var _u = (0, react_1.useState)(null), formValues = _u[0], setFormValues = _u[1];
    // const { isShowBonus, bonus } = useSignUpBonus()
    var _v = (0, react_1.useState)(true), showForm = _v[0], setShowForm = _v[1];
    var globalConfig = (0, swr_hooks_1.useConfig)();
    var lang = (0, next_intl_1.useLocale)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var backUrl = searchParams.get('back');
    var t = (0, next_intl_1.useTranslations)('translation');
    var tPtomotions = (0, next_intl_1.useTranslations)('promotions');
    var bonusesData = (0, swr_hooks_1.useCalculateWelcomePackage)();
    var router = (0, navigation_1.useRouter)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var _w = (0, react_1.useState)(lockrWrapper(function () { return Lockr.get(AUTH_TYPE); }) || 'email'), authType = _w[0], setAuthType = _w[1];
    var geo = (0, swr_hooks_1.useGeo)().data;
    var config = (0, swr_hooks_1.useConfig)();
    var isTwoStepSignUpEnabled = (0, react_1.useMemo)(function () { var _a; return Boolean((_a = config === null || config === void 0 ? void 0 : config.features) === null || _a === void 0 ? void 0 : _a.signUpTwoStep); }, [(_b = config === null || config === void 0 ? void 0 : config.features) === null || _b === void 0 ? void 0 : _b.signUpTwoStep]);
    (0, react_2.useEffect)(function () {
        if (isUserWasAuth && isAuth) {
            if (backUrl)
                return router.replace(backUrl);
            router.replace('/');
        }
    }, [isUserWasAuth, router, isAuth, backUrl]);
    (0, react_2.useEffect)(function () {
        if (((geo === null || geo === void 0 ? void 0 : geo.geoData.countryCode) && (geo === null || geo === void 0 ? void 0 : geo.geoData.countryCode) === 'UZ') ||
            lang === 'uz') {
            Lockr.set('authType', 'phone');
            setAuthType('phone');
        }
        else {
            Lockr.set('authType', 'email');
            setAuthType('email');
        }
    }, [(_c = geo === null || geo === void 0 ? void 0 : geo.geoData) === null || _c === void 0 ? void 0 : _c.countryCode]);
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var onClickClose = (0, react_1.useCallback)(function () {
        showForm ? setShowForm(false) : closeModal();
    }, [closeModal, showForm]);
    var backToForm = (0, react_1.useCallback)(function () {
        setShowForm(true);
    }, []);
    var setAuthTypeHandler = function (type) {
        setAuthType(type);
        lockrWrapper(function () { return Lockr.set(AUTH_TYPE, type); });
    };
    var handleSignUpSuccess = (0, react_1.useCallback)(function (values) {
        if (!isTwoStepSignUpEnabled)
            return;
        setFormValues(function (prev) { return (__assign(__assign({}, (prev || {})), values)); });
        setStep('details');
    }, [isTwoStepSignUpEnabled]);
    var backToPreviousStep = (0, react_1.useCallback)(function (values) {
        if (values)
            setFormValues(function (prev) { return (__assign(__assign({}, (prev || {})), values)); });
        setStep('signup');
    }, []);
    var defaultPhoneCountry = typeof (formValues === null || formValues === void 0 ? void 0 : formValues.country) === 'string'
        ? formValues === null || formValues === void 0 ? void 0 : formValues.country
        : (_d = formValues === null || formValues === void 0 ? void 0 : formValues.country) === null || _d === void 0 ? void 0 : _d.value;
    return (react_1.default.createElement(ui_components_1.Modal
    // className={`${styles.modalSignUp} ${isShowBonus ? styles.withBonus : ''}`}
    , { 
        // className={`${styles.modalSignUp} ${isShowBonus ? styles.withBonus : ''}`}
        width: "420px", padding: "16px", onClose: onClickClose, className: "".concat(styles_module_scss_1.default.modalSignUp), saveSize: true, overflowY: "visible" },
        showForm && (react_1.default.createElement("div", { className: styles_module_scss_1.default.welcomeTo }, isTwoStepSignUpEnabled && step === 'details'
            ? t('finalStep')
            : t('welcomeTo'))),
        step === 'signup' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.logo },
            react_1.default.createElement("img", { src: "/img/logo.svg", alt: "logo" }))),
        (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enabledEmailAndPhoneSignUp) ? (react_1.default.createElement(SwitchAuthType_1.default, { authType: authType, setAuthType: setAuthTypeHandler, geo: (_e = geo === null || geo === void 0 ? void 0 : geo.geoData) === null || _e === void 0 ? void 0 : _e.countryCode })) : null,
        (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.signUpWelcomePackageBonus) && showForm && (react_1.default.createElement("div", { className: styles_module_scss_1.default.welcomeBonus },
            react_1.default.createElement("span", null, tPtomotions('welcomeBonusTitle')),
            react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                    __html: t('upToFresspins', {
                        maxBonus: "".concat(bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.amount, " ").concat((0, apps_shared_1.getCurrencySymbol)(bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currency)),
                        freespins: bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.freeSpins,
                    }).replace('<br/>', ''),
                } }))),
        (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.signUpWelcomeCurrentBonus) && showForm && (react_1.default.createElement("div", { className: styles_module_scss_1.default.welcomeBonus },
            react_1.default.createElement("span", null, tPtomotions('welcomeBonusTitle')),
            !!((_f = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _f === void 0 ? void 0 : _f.percent) &&
                Number(bonusesData.currentBonus.percent) !== 0 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.promoText },
                react_1.default.createElement("strong", null, (_g = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _g === void 0 ? void 0 : _g.percent),
                "\u00A0",
                t('upTo'),
                "\u00A0",
                react_1.default.createElement("strong", null, (_h = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _h === void 0 ? void 0 :
                    _h.amount,
                    (0, apps_shared_1.getCurrencySymbol)(bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currency)),
                !!((_j = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _j === void 0 ? void 0 : _j.fs) &&
                    (!!((_k = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _k === void 0 ? void 0 : _k.percent) ? (react_1.default.createElement(react_1.default.Fragment, null,
                        ' ',
                        "+\u00A0",
                        react_1.default.createElement("strong", null, (_l = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _l === void 0 ? void 0 : _l.fs),
                        ' ',
                        t('freespins'))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("strong", null, (_m = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _m === void 0 ? void 0 : _m.fs),
                        ' ',
                        t('freespins')))),
                ((_o = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _o === void 0 ? void 0 : _o.addedToBalanceAmount) ? (react_1.default.createElement(react_1.default.Fragment, null, (_p = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currentBonus) === null || _p === void 0 ? void 0 :
                    _p.addedToBalanceAmount,
                    (0, apps_shared_1.getCurrencySymbol)(bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.currency))) : null)))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, showForm ? (step === 'details' && isTwoStepSignUpEnabled ? (react_1.default.createElement(FinalStepForm_1.default, { authInputMode: authInputMode, defaultPhoneCountry: defaultPhoneCountry, initialValues: formValues, onBack: backToPreviousStep, withTitle: false })) : (react_1.default.createElement(SignUpForm_1.default, { withLabels: withLabels, welcomeFields: welcomeFields, authInputMode: authInputMode, signUpType: authType, initialValues: formValues, onSubmit: isTwoStepSignUpEnabled ? handleSignUpSuccess : undefined }))) : (react_1.default.createElement(UserBackNotification_1.default, { backToForm: backToForm })))));
};
exports.default = SignUpNew;
